var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1176_186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 11.6914C5.78516 11.6914 5.61865 11.5249 5.61865 11.3047V10.4185C4.07715 10.3057 2.89014 9.52686 2.57324 8.36133C2.54102 8.24854 2.5249 8.14648 2.5249 8.0498C2.5249 7.6792 2.74512 7.42676 3.14258 7.42676C3.45947 7.42676 3.66895 7.59863 3.78711 7.91016C4.0127 8.70508 4.64111 9.18311 5.61865 9.28516V6.1001L5.35547 6.03564C3.54541 5.60596 2.66992 4.80566 2.66992 3.479C2.66992 1.99658 3.87842 0.965332 5.61865 0.831055V-0.0283203C5.61865 -0.248535 5.78516 -0.42041 6 -0.42041C6.22021 -0.42041 6.38672 -0.248535 6.38672 -0.0283203V0.836426C7.86914 0.95459 8.96484 1.75488 9.26562 2.86133C9.29785 2.96875 9.31396 3.07617 9.31396 3.17822C9.31396 3.53271 9.09375 3.76367 8.70703 3.76367C8.39551 3.76367 8.18066 3.60791 8.05176 3.29102C7.79395 2.52832 7.21924 2.07178 6.38672 1.96973V5.00439L6.71436 5.07959C8.62646 5.53076 9.49658 6.32031 9.49658 7.68994C9.49658 9.32812 8.14307 10.2949 6.38672 10.4185V11.3047C6.38672 11.5249 6.22021 11.6914 6 11.6914ZM3.98047 3.38232C3.98047 4.10205 4.50684 4.54785 5.61865 4.82178V1.96973C4.57666 2.08789 3.98047 2.68408 3.98047 3.38232ZM8.18604 7.80273C8.18604 6.9917 7.67578 6.5835 6.38672 6.27734V9.29053C7.52002 9.19922 8.18604 8.66748 8.18604 7.80273Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1176_186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.13e22a7c7dae1cf564b39782c900b517.svg";
export { ForwardRef as ReactComponent };